var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEthereum = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#8c8c8c}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    style: {
      fill: "#343434"
    },
    d: "m250 67.5-2.5 8.3v241.4l2.5 2.4 112-66.2z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st1",
    d: "M250 67.5 137.9 253.4 250 319.6V202.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#3c3c3b"
    },
    d: "m250 340.8-1.4 1.7v86l1.4 4 112.1-157.9z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M250 432.5v-91.7l-112.1-66.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    style: {
      fill: "#141414"
    },
    d: "m250 319.6 112-66.2-112-50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      fill: "#393939"
    },
    d: "M137.9 253.4 250 319.6V202.5z"
  })));
};
export default SvgEthereum;